/* unplugin-vue-components disabled */
import {markRaw} from 'vue'
import {DATES} from '../pulse-defs'
import {PulseInput} from 'components/pulse'

export default {
  components: {PulseInput},
  mixins: [ModelValue(String)],
  data() {
    return {
      show: false,
      dates: markRaw(DATES)
    }
  },
  computed: {
    c_dates() {
      if (!this.$responsive.mobile) return this.dates
      return this.dates.filter(d => d.value !== 'date_range')
    },
    c_value() {
      return DATES.find(d => d.value === this.value).title
    }
  },
  methods: {
    onChange(val){
      this.value = val
      this.show = false
    },
  }
}
